import type {ReactNode} from 'react'
import type {LucideIcon} from 'lucide-react'

interface SectionPageHeaderProps {
    icon: LucideIcon
    title: ReactNode
    description?: ReactNode
    actions?: ReactNode
    'data-testid'?: string
}

export function SectionPageHeader({icon: Icon, title, description, actions, 'data-testid': testId}: SectionPageHeaderProps) {
    return (
        <div className={actions !== undefined ? 'flex items-start justify-between mb-6' : 'mb-6'}>
            <div>
                <h1 className="flex font-bold gap-3 items-center text-2xl tracking-tight" data-testid={testId ?? 'section-page-header-title'}>
                    <Icon className="h-6 w-6"/>
                    {title}
                </h1>
                {description !== undefined && (
                    <p data-testid="section-page-header-description" className="text-muted-foreground mt-2">{description}</p>
                )}
            </div>
            {actions !== undefined && (
                <div>{actions}</div>
            )}
        </div>
    )
}
